import type {ValidationMessageTemplate} from "@vee-validate/i18n"

export default {
    messages: {
        "verify_password": "Password is not strong enough. Please use a different password",
        "confirm_password": "The passwords do not match",
        "verify_url": "URL is invalid",
        "validation_pending": "Verifying...",
        "editor_content_required": "{field} is required",
        "puzzle_unsolved": "This puzzle is still unsolved..."
    }
} as {
    messages: Record<string, ValidationMessageTemplate>
}